import React, { useState, useContext } from "react";
import { NavLink, Routes, Route, useNavigate } from "react-router-dom";
import { logout } from "../../utils/auth";
import {
  LayoutDashboard,
  Bell,
  FileBarChart2,
  Camera,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Shield,
} from "lucide-react";

import Dashboard from "./tanDashboard";
import Alerts from "./tanAlert";
import Personcount from "./tanPersoncount";
import Report from "./tanReport";
import TanCameraView from "./tanCamera";
import { RootContext } from "../../context/RootContext";

const navItems = [
  {
    label: "Dashboard",
    icon: LayoutDashboard,
    path: "/tanseeqhome",
    exact: true,
  },
  {
    label: "Alerts",
    icon: Bell,
    path: "/tanseeqhome/alerts",
  },
  {
    label: "Reports",
    icon: FileBarChart2,
    path: "/tanseeqhome/reports",
  },
  {
    label: "Person Count",
    icon: Shield,
    path: "/tanseeqhome/personcount",
  },
  {
    label: "Cameras",
    icon: Camera,
    path: "/tanseeqhome/cameras",
  }
];

const Layout = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const { dispatch } = useContext(RootContext);
  

  const handleLogout = async () => {
    await logout();
    dispatch({ type: "LOGOUT" });
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 font-sans">
      {/* ── Top Bar ── */}
      <header className="sticky top-0 z-50 h-[60px] flex items-center px-6 backdrop-blur-xl bg-white/95 border-b border-slate-200">
        {/* Logo */}
        <div className="flex items-center shrink-0">
          <div className="flex items-center justify-center">
            <img
              src="/logo.png"
              alt="Logo"
              className="h-[42px] w-auto object-contain"
            />
          </div>
          <div className="mx-5 h-8 w-px bg-slate-200" />
          <div className="flex flex-col">
            <span className="text-[15px] font-bold tracking-[-0.3px] text-slate-900">
              CogniVision
            </span>
            <span className="text-[10px] font-semibold tracking-[0.18em] text-slate-500 uppercase">
              Next Gen Video Analytics Platform
            </span>
          </div>
        </div>

        {/* ── TRY EACH OPTION BELOW BY REPLACING THIS SECTION ── */}
        
        {/* OPTION 1: Same Height as Main Logo */}
        <div className="ml-auto flex items-center gap-4">
          <div className="flex items-center justify-center">
            <img
              src="/tanseeq.png"
              alt="Logo 1"
              className="h-[42px] w-auto object-contain px-1"
            />
          </div>
          <div className="h-8 w-px bg-slate-200" />
          <button
            onClick={handleLogout}
            className="flex items-center justify-center w-9 h-9 rounded-lg border border-red-200 bg-red-50 text-red-600 hover:bg-red-100 transition-all hover:scale-105"
            title="Logout"
          >
            <LogOut size={18} />
          </button>
        </div>
      </header>

      <div className="flex flex-1 overflow-hidden">
        {/* ── Sidebar ── */}
        <aside
          className={`fixed top-[60px] left-0 z-40 h-[calc(100vh-60px)] bg-white/95 border-r border-slate-200 flex flex-col transition-all duration-300 ${
            collapsed ? "w-16" : "w-[220px]"
          }`}
        >
          <div
            className={`flex ${
              collapsed ? "justify-center" : "justify-end"
            } px-3 pt-3 pb-1`}
          >
            <button
              onClick={() => setCollapsed(!collapsed)}
              className="w-7 h-7 rounded-md border border-slate-200 bg-slate-100 flex items-center justify-center text-slate-600 hover:bg-slate-200 transition-all"
            >
              {collapsed ? (
                <ChevronRight size={14} />
              ) : (
                <ChevronLeft size={14} />
              )}
            </button>
          </div>

          <nav className="flex-1 px-2 py-2 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.exact}
                className={({ isActive }) =>
                  `
                  flex items-center
                  ${collapsed ? "justify-center" : "justify-start"}
                  ${collapsed ? "gap-0" : "gap-2.5"}
                  px-3 py-2.5 rounded-[10px]
                  text-[13px] font-semibold
                  transition-all duration-150
                  border
                  ${
                    isActive
                      ? "bg-blue-50 text-blue-600 border-blue-100"
                      : "text-slate-500 border-transparent hover:bg-slate-100"
                  }
                `
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      size={17}
                      color={isActive ? "#2563eb" : "#64748b"}
                    />
                    {!collapsed && <span>{item.label}</span>}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* ── Main Content ── */}
        <main
          className={`flex-1 overflow-y-auto p-7 min-h-[calc(100vh-60px)] bg-slate-50 transition-all duration-300 ${
            collapsed ? "ml-16" : "ml-[220px]"
          }`}
        >
          <Routes>
            <Route index element={<Dashboard />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="reports" element={<Report />} />
            <Route path="personcount" element={<Personcount />} />
            <Route path="cameras" element={<TanCameraView />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Layout;